import { createAction } from "redux-actions";

import { moduleSlug } from "../constants";

export const initUsersModuleAction = createAction(`${moduleSlug}/initUsersModuleAction`);